import { Box } from 'native-base';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ProgressBar from 'src/components/ProgressBar';
import { IStore } from 'src/redux/reducers';
import { containerStyle } from 'src/styles/containerStyle';
import { Platform } from 'react-native';

export default function LoginPlaceholder({ navigation }) {

    const [showLoadingIndicator, setShowLoadingIndicator] = React.useState(true);
    const loginStatus = useSelector((store: IStore) => store.login.userLoggedIn);

    useEffect(() => {
        if (loginStatus === "NOT_LOGGED_IN") {
            setShowLoadingIndicator(false)

            // Check if user is trying to access a public route
            if (Platform.OS === 'web') {
                const currentPath = window.location.pathname;
                const publicRoutes = ['/product-release', '/privacy-policy', '/account-deletion'];

                if (publicRoutes.includes(currentPath)) {
                    const routeByPath: Record<string, string> = {
                        '/product-release': 'ProductRelease',
                        '/privacy-policy': 'PrivacyPolicy',
                        '/account-deletion': 'AccountDeletion',
                    };
                    navigation.navigate(routeByPath[currentPath]);
                    return;
                }
            }

            navigation.navigate("Login")
        }
    }, [loginStatus]);

    return (
        <Box variant={"main"} style={
            [containerStyle.mainContainer]
        }>
            <ProgressBar isVisible={showLoadingIndicator} progressText="Checking login status..." />
        </Box>
    );
}
